import { Layout } from 'lib/types/layout';
import { OrderImage } from 'lib/orders/images';
import { MediaModel } from 'lib/model/objects/mediaModel';
import { LayoutModel } from 'lib/model/objects/layoutModel';
import { NewOrderImageEditor } from './NewOrderImageEditor';

type OrderImageEditorProps = {
  position: 'top' | 'bottom';
  orderImages: (OrderImage | null)[];
  mediaList: MediaModel[] | null;
  onUpdateImages: (updatedImages: (OrderImage | null)[]) => void;
  layout: Layout;
  disableEditing?: boolean;
  advertiserLogo?: string;
};

export default function OrderImageEditor({
  position,
  orderImages,
  onUpdateImages,
  mediaList,
  layout,
  disableEditing,
  advertiserLogo
}: OrderImageEditorProps) {
  const layoutModel = new LayoutModel(layout);
  if (layoutModel.imageCount === 0) {
    return null;
  }

  const insertImageAtIndex = (index: number, newOrderImage: OrderImage) => {
    const newOrderImages = [...orderImages];
    newOrderImages[index] = newOrderImage;
    onUpdateImages(newOrderImages);
  };

  const removeImageAtIndex = (index: number) => {
    const newOrderImages = [...orderImages];
    newOrderImages[index] = null;
    onUpdateImages(newOrderImages);
  };

  return (
    <NewOrderImageEditor
      position={position}
      orderImages={orderImages}
      mediaList={mediaList}
      insertImageAtIndex={insertImageAtIndex}
      removeImageAtIndex={removeImageAtIndex}
      layout={layout}
      disableEditing={disableEditing}
      advertiserLogo={advertiserLogo}
    />
  );
}
